import styled from "@emotion/styled";
import Button from "metabase/core/components/Button";
export const WidgetButton = styled(Button)`
  color: #000000;
  padding: 0;
  border: none;
  border-radius: 0;

  &:hover {
    background-color: transparent;
  }
`;
